import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { Button, Card, Col, Container, Dropdown, DropdownButton, Form, Row } from "react-bootstrap";
import { PencilIcon } from '@primer/octicons-react'
import { BiCalendar, BiXCircle } from "react-icons/bi";
import DateTimePicker from 'react-datetime-picker';
import { axiosAuth_PLATFORM_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import { translateAPIError } from '../utils/apiUtils';
import { formatDate, formatDateOnly } from '../utils/timeUtils';


const SaasTenantAdminDetailsView = (props) => {

  // Utilities
  const { i18n, t } = useTranslation(['common', 'custom']);
  const navigate = useNavigate();

  // Initialize with actual JSON obj.  If not, will get error.
  const [objAttrs, setObjAttrs] = useState({
  });

  const [currentObjAttrs, setCurrentObjAttrs] = useState([]);

  const subsPlanOptions = [ 
    { key: "MONTHLY", value: "MONTHLY" },
    { key: "1_YEAR",  value: "1_YEAR" },
    { key: "2_YEAR",  value: "2_YEAR" },
    { key: "3_YEAR",  value: "3_YEAR" }
  ];

  const statusOptions = [ 
    { key: "ACTIVE",     value: "ACTIVE" },
    { key: "PENDING",    value: "PENDING" },
    { key: "EXPIRED",    value: "EXPIRED" },
    { key: "TERMINATED", value: "TERMINATED" }
  ];

  // Initialize state
  useEffect(() => {

    if (props) {
      fetchObj(props.objDetails.id);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);


  const fetchObj = (id) => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.get("saas-tenants/" + id);

        resolve(res.data);

        if (res.status === 200) {
          setObjAttrs(res.data[0]);
          setCurrentObjAttrs(res.data[0]);
        }

        setErrMsg('');
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }

  // View vs Edit Modes
  const [editMode, setEditMode] = useState(false);

  const [errMsg, setErrMsg] = useState('');

  const handleEditAttrs = (e) => {
    e.preventDefault();
    setEditMode(true);
  }

  const onAttrsInputChange = (e) => {
    setObjAttrs({ ...objAttrs, [e.target.name]: e.target.value })
  }

  const onDropdownSelect = (target, key) => {

    switch (target) {
      case 'subsPlan':
        setObjAttrs({ ...objAttrs, subsPlan: key })
        break;
      case 'status':
        setObjAttrs({ ...objAttrs, status: key })
        break;
      default:
        break;
    }
  }; 

  const onDatepickerChange = (target, value) => {

    switch (target) {
      case 'planStartDate':
        setObjAttrs({ ...objAttrs, planStartDate: value.toISOString() })
        break;
      case 'planExpireDate':
        setObjAttrs({ ...objAttrs, planExpireDate: value.toISOString() })
        break;
      default:
        break;
    }
  }

  const handleEditCancel = (e) => {
    e.preventDefault();

    // Reset fields
    setObjAttrs(currentObjAttrs);

    setEditMode(false);
  }

  const handleEditSubmit = (e) => {
    e.preventDefault();

    // Validate form inputs
    if (!objAttrs.name || objAttrs.name.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_name"));
      return;
    } else if (objAttrs.name.length > 50) {
      setErrMsg(t("I18N_ERR_Max_len_name") + 50);
      return;

    } else if (objAttrs.description.length > 250) {
      setErrMsg(t("I18N_ERR_Max_len_desc") + 250);
      return;

    }

    const reqBody = objAttrs;

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.put("saas-tenants/" + objAttrs.id, reqBody);

        resolve(res.data);

        if (res.status === 200) {

          // Restore UI to viewing mode
          setEditMode(false);

          fetchObj(objAttrs.id);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });

  }


  const handleClose = (e) => {
    e.preventDefault();

    // Return to list
    navigate(-1);
  }


  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
        <span className={classes.admin_pages__page_title}>
          {t("I18N_SaasTenant_Details")}
        </span>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_SaasTenant_info")}
            </span>
            {editMode ?
              null
              :
              <span style={{marginLeft:'15px', fontSize:'9px', color:'SteelBlue', cursor:'pointer'}} onClick={handleEditAttrs}>
                <PencilIcon size={12} />
                {t("I18N_Edit")}
              </span>
            }
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

          {editMode ?
            <Container>
              <form>
                <Row className={classes.admin_pages__field_label}>
                  <Col>{t("I18N_SaasTenant_name")}: *</Col>
                  <Col>{t("I18N_Description")}: *</Col>
                  <Col>{t("I18N_License_key")}:</Col>
                  <Col>{t("I18N_Status")}: *</Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>
                    <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="name" value={objAttrs.name}
                      onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                  <Col>
                    <textarea className={classes.admin_pages__field_editable} style={{minWidth: '100%', minHeight:'100px', backgroundColor:'white'}}
                              name="description" value={objAttrs.description}
                      onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                  <Col>
                    <textarea className={classes.admin_pages__field_editable} style={{minWidth: '100%', minHeight:'100px', backgroundColor:'white'}}
                              name="licenseKey" value={objAttrs.licenseKey}
                      onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                  <Col>
                    <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                      title={ !objAttrs.status ? t("common:I18N_DROPDOWN_PROMPT") : t("I18N_ST_" + objAttrs.status) }
                      onSelect={(key) => onDropdownSelect('status', key)}>
                      {statusOptions.map((item, index) => {
                        return (
                          <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                            {t("I18N_ST_" + item.value)}
                          </Dropdown.Item>
                        );
                      })}
                    </DropdownButton>
                  </Col>
                </Row>

                <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                  <Col>{t("I18N_SubsPlan")}:</Col>
                  <Col>{t("I18N_Plan_start_date")}: *</Col>
                  <Col>{t("I18N_Plan_expiration_date")}:</Col>
                  <Col></Col>
                </Row>
                <Row className={classes.admin_pages__field_label}>
                  <Col>
                    <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                      title={ !objAttrs.subsPlan ? t("common:I18N_DROPDOWN_PROMPT") : t("I18N_" + objAttrs.subsPlan) }
                      onSelect={(key) => onDropdownSelect('subsPlan', key)}>
                      {subsPlanOptions.map((item, index) => {
                        return (
                          <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                            {t("I18N_" + item.value)}
                          </Dropdown.Item>
                        );
                      })}
                    </DropdownButton>
                  </Col>
                  <Col>
                    <DateTimePicker onChange={(value) => onDatepickerChange('planStartDate', value)} value={objAttrs.planStartDate}
                      format={ (objAttrs.mfrDate != null) ? "y-MM-dd" : "y-MM-dd" }
                      disableClock="true"
                      clearIcon=<BiXCircle size={16} style={{color:"gray"}}/>
                      calendarIcon=<BiCalendar size={16} style={{color:"gray"}}/>
                      locale={i18n.language === 'zh_HK' ? "zh-HK" : (i18n.language === 'zh_CN' ? "zh-CN" : "en")}
                    />
                  </Col>
                  <Col>
                    <DateTimePicker onChange={(value) => onDatepickerChange('planExpireDate', value)} value={objAttrs.planExpireDate}
                      format={ (objAttrs.mfrDate != null) ? "y-MM-dd" : "y-MM-dd" }
                      disableClock="true"
                      clearIcon=<BiXCircle size={16} style={{color:"gray"}}/>
                      calendarIcon=<BiCalendar size={16} style={{color:"gray"}}/>
                      locale={i18n.language === 'zh_HK' ? "zh-HK" : (i18n.language === 'zh_CN' ? "zh-CN" : "en")}
                    />
                  </Col>
                  <Col></Col>
                </Row>

                <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                  <Col>{t("I18N_Contact_name")}: *</Col>
                  <Col>{t("I18N_Contact_email")}: *</Col>
                  <Col>{t("I18N_Contact_phone")}:</Col>
                  <Col></Col>
                </Row>
                <Row className={classes.admin_pages__field_label}>
                  <Col>
                    <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="name" value={objAttrs.contactName}
                      onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                  <Col>
                    <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="name" value={objAttrs.contactEmail}
                      onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                  <Col>
                    <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="name" value={objAttrs.contactPhone}
                      onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                  <Col></Col>
                </Row>

                <Row className={classes.admin_pages__field_label} style={{marginTop:'10px', fontStyle:'italic'}}>
                  <span>{t("I18N_Req_fields")}</span>
                </Row>

                <Row>
                  <div display='flex' style={{marginTop:'15px'}}>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ float: 'left' }}
                      onClick={handleEditCancel}>
                      {t("I18N_Cancel")}
                    </Button>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ marginLeft: '15px' }}
                      onClick={handleEditSubmit}>
                      {t("I18N_Save")}
                    </Button>
                    <span className={classes.admin_pages__field_label} style={{marginLeft:'30px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                      {errMsg}
                    </span>
                  </div>
                </Row>
              </form>
            </Container>
            :
            <Container>
              <Row className={classes.admin_pages__field_label}>
                <Col>{t("I18N_SaasTenant_name")}: *</Col>
                <Col>{t("I18N_Description")}: *</Col>
                <Col>{t("I18N_License_key")}:</Col>
                <Col>{t("I18N_Status")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col>{objAttrs.name}</Col>
                <Col style={{maxHeight:'120px', overflow:'auto', flexWrap:'wrap', wordWrap:'break-word'}}>
                  {objAttrs.description}
                </Col>
                <Col style={{maxHeight:'120px', overflow:'auto', flexWrap:'wrap', wordWrap:'break-word'}}>
                  {objAttrs.licenseKey}
                </Col>
                <Col>{t("I18N_ST_" + objAttrs.status)}</Col>
              </Row>


              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col>{t("I18N_SubsPlan")}:</Col>
                <Col>{t("I18N_Plan_start_date")}:</Col>
                <Col>{t("I18N_Plan_expiration_date")}:</Col>
                <Col></Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col>{t("I18N_" + objAttrs.subsPlan)}</Col>
                <Col>{objAttrs.planStartDate  ? formatDateOnly(objAttrs.planStartDate)  : null}</Col>
                <Col>{objAttrs.planExpireDate ? formatDateOnly(objAttrs.planExpireDate) : null}</Col>
                <Col></Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col>{t("I18N_Contact_name")}:</Col>
                <Col>{t("I18N_Contact_email")}:</Col>
                <Col>{t("I18N_Contact_phone")}:</Col>
                <Col></Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col>{objAttrs.contactName}</Col>
                <Col>{objAttrs.contactEmail}</Col>
                <Col>{objAttrs.contactPhone}</Col>
                <Col></Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                  <Col>{t("I18N_Updated_by")}:</Col>
                  <Col>{t("I18N_Time_updated")}:</Col>
                  <Col>{t("I18N_Created_by")}:</Col>
                  <Col>{t("I18N_Time_created")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col>{objAttrs.updaterUsername}</Col>
                <Col>{formatDate(objAttrs.timeUpdated)}</Col>
                <Col>{objAttrs.creatorUsername}</Col>
                <Col>{formatDate(objAttrs.timeCreated)}</Col>
              </Row>
            </Container>
          }
        </div>

        <hr className="solid" style={{ marginTop: '30px' }}></hr>

        <div className={classes.admin_pages__page_subtitle} style={{ marginTop: '20px' }}>
          <Form.Group as={Row} className="mb-2 mt-3">
            <div style={{ display: "flex" }}>
              <Button size="sm" variant="outline-secondary" className="mb-3"
                style={{ fontSize: '12px', fontWeight: '300' }}
                onClick={handleClose}>
                {t("I18N_Close")}
              </Button>
            </div>
{/*
            <span className={classes.admin_pages__field_label} style={{ color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
              {updateObjErrMsg}
            </span>
*/}
          </Form.Group>
        </div>

      </Card>
    </>
  );
}

export default SaasTenantAdminDetailsView;
